<template>
  <template v-if="!!formInputs?.form?.record">
    <v-card class="my-4 pa-4">
      <v-card-title class="headline">
        RECORD
      </v-card-title>
      <v-card-subtitle>
        {{ i18n.global.t('pages.vehicles.form.iniFileSetting.subtitles.record') }}
      </v-card-subtitle>
      <v-card-text>
        <Record1ChSetting
          v-model="form"
          :selectDefault="selectDefault"
          :errors="errors"
          :formInputs="formInputs"
          :isOperationOffice="isOperationOffice"
          :isInstallationOffice="isInstallationOffice"
          :commonCameraOn="commonCameraOn"
        />
        <v-divider class="my-4"></v-divider>
        <Record2ChSetting
          v-model="form"
          :selectDefault="selectDefault"
          :errors="errors"
          :formInputs="formInputs"
          :isOperationOffice="isOperationOffice"
          :isInstallationOffice="isInstallationOffice"
        />
        <v-divider class="my-4"></v-divider>
        <Record3ChSetting
          v-model="form"
          :selectDefault="selectDefault"
          :errors="errors"
          :formInputs="formInputs"
          :isOperationOffice="isOperationOffice"
          :isInstallationOffice="isInstallationOffice"
        />
        <v-divider class="my-4"></v-divider>
        <Record4ChSetting
          v-model="form"
          :selectDefault="selectDefault"
          :errors="errors"
          :formInputs="formInputs"
          :isOperationOffice="isOperationOffice"
          :isInstallationOffice="isInstallationOffice"
        />
        <v-divider class="my-4"></v-divider>
        <RecordAudioSetting
          v-model="form"
          :selectDefault="selectDefault"
          :errors="errors"
          :formInputs="formInputs"
          :isOperationOffice="isOperationOffice"
          :isInstallationOffice="isInstallationOffice"
        />
      </v-card-text>
    </v-card>
  </template>
</template>

<script>
import i18n from "@/lang/i18n";
import Record1ChSetting from "@/components/VehicleFormParts/Record1ChSetting.vue";
import Record2ChSetting from "@/components/VehicleFormParts/Record2ChSetting.vue";
import Record3ChSetting from "@/components/VehicleFormParts/Record3ChSetting.vue";
import Record4ChSetting from "@/components/VehicleFormParts/Record4ChSetting.vue";
import RecordAudioSetting from "@/components/VehicleFormParts/RecordAudioSetting.vue";

export default {
  props: {
    modelValue: {},
    formInputs: {},
    selectDefault: {
      type: Boolean,
      default: false,
    },
    isOperationOffice: {
      type: Boolean,
      default: false,
    },
    isInstallationOffice: {
      type: Boolean,
      default: false,
    },
    commonCameraOn: {
      type: String,
      default: 'OFF',
    },
    errors: {},
  },
  data() {
    return {
      form: {},
      readonlyInputs: [],
      errorKeyPrefix: "initial_params.record",
    };
  },
  computed: {
    i18n() {
      return i18n
    },
  },
  watch: {
    modelValue: {
      handler() {
        const defaultValues = {
          camf_pixel: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectPixelFHD'),
          camf_bitrate: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectBitrateLow'),
          camf_fps: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectFps15'),
          camf_h: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectHorizonNormal'),
          camf_v: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectVerticalNormal'),
          sound_on: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectSoundOnOn'),
          camr_on: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectCameraOnOff'),
          camr_pixel: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectPixelFHD'),
          camr_bitrate: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectBitrateLow'),
          camr_fps: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectFps15'),
          camr_h: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectHorizonNormal'),
          camr_v: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectVerticalNormal'),
          cami_on: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectCameraOnOff'),
          cami_pixel: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectPixelFHD'),
          cami_bitrate: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectBitrateLow'),
          cami_fps: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectFps15'),
          cami_h: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectHorizonNormal'),
          cami_v: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectVerticalNormal'),
          cams_on: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectCameraOnOff'),
          cams_pixel: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectPixelFHD'),
          cams_bitrate: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectBitrateLow'),
          cams_fps: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectFps15'),
          cams_h: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectHorizonNormal'),
          cams_v: i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectVerticalNormal'),
        };
        const newForm = { ...defaultValues, ...this.modelValue };
        
        // 内容が違かったらアップデート(無限Loop防止)
        if (JSON.stringify(this.form) !== JSON.stringify(newForm)) {
          this.form = newForm;
        }
      },
      immediate: true,
    },
    formInputs: {
      handler() {
        if (!this.formInputs?.form?.record) return;
        const key = Object.keys(this.formInputs.default_params)[0];
        this.readonlyInputs = Object.keys(
          this.formInputs.default_params[key]?.parameters?.record ?? []
        );
      },
    },
    form: {
      handler() {
        this.$emit("update:modelValue", this.form);
      },
      deep: true,
    },
  },
  components: {
    RecordAudioSetting,
    Record1ChSetting,
    Record2ChSetting,
    Record3ChSetting,
    Record4ChSetting,
  },
};
</script>

<style scoped>
.headline {
  font-size: 24px;
  font-weight: bold;
  color: #0088a6;
}
</style>
